/* eslint-disable max-classes-per-file */
import { ResponseStepsRewardRegister } from "./postRewardRegisterCheckOtpInterface";

export interface RequestProvinceRegisterListInterface {
  AccountId: string | undefined;
  AcceptLanguage: string;
}

export class DataProvinceRegisterInterface {
  id: string;

  name: string;

  constructor(data: any) {
    this.id = data.id || "";
    this.name = data.name || "";
  }
}

export class DataPrizeInterface {
  isPrizeRunOut: boolean;

  countReceivedPrize: number;

  totalPrizeLeft: number;

  totalPrize: number;

  totalPrizeLeftFormat: string;

  totalPrizeFormat: string;

  constructor(data: any) {
    this.isPrizeRunOut = data?.isPrizeRunOut || false;
    this.countReceivedPrize = data?.countReceivedPrize || 0;
    this.totalPrizeLeft = data?.totalPrizeLeft || 0;
    this.totalPrize = data?.totalPrize || 0;
    this.totalPrizeLeftFormat =
      new Intl.NumberFormat("en-US").format(data?.totalPrizeLeft) || "";
    this.totalPrizeFormat =
      new Intl.NumberFormat("en-US").format(data?.totalPrize) || "";
  }
}

export class ResponseProvinceRegisterListInterface {
  status: boolean;

  message: string;

  data: {
    provinces: DataProvinceRegisterInterface[];
    steps: ResponseStepsRewardRegister;
    prizeData: DataPrizeInterface;
  };

  constructor(data: any) {
    this.status = data?.status || "";
    this.message = data?.message || "";
    this.data = {
      provinces: (data?.data?.provinces || []).map(
        (result: any) => new DataProvinceRegisterInterface(result),
      ),
      steps:
        new ResponseStepsRewardRegister(data?.data?.steps) ||
        new ResponseStepsRewardRegister({}),
      prizeData: new DataPrizeInterface({
        isPrizeRunOut: data?.data?.isPrizeRunOut,
        countReceivedPrize: data?.data?.countReceivedPrize,
        totalPrizeLeft: data?.data?.totalPrizeLeft,
        totalPrize: data?.data?.totalPrize,
      }),
    };
  }
}
